/**
 * Security issue remediation suggestions.
 * Maps issue types to recommended fixes.
 */

// Mapping of issue types to suggested fixes
const suggestedFixesByType: Record<string, string> = {
  PII_DETECTION:
    "Implement automatic PII redaction using anonymization filters. Consider adding a pre-processing layer that detects and masks sensitive data before it reaches the model.",
  PROMPT_INJECTION:
    "Enable prompt injection detection scanner. Add input validation to detect and block manipulation attempts. Consider implementing prompt templates with strict parameter validation.",
  DATA_EXFILTRATION:
    "Restrict model output to prevent structured data exposure. Implement output filtering to detect and block database schema or sensitive system information in responses.",
  TOXIC_CONTENT:
    "Enable toxicity scanner with stricter thresholds. Implement content moderation filters and consider adding a review queue for borderline cases.",
  MALICIOUS_URL:
    "Implement URL scanning and validation. Block URLs from known malicious domains and validate all URLs against threat intelligence feeds before including in responses.",
  SECRETS_EXPOSURE:
    "Enable secrets scanner for both input and output. Implement automatic redaction of API keys, tokens, and credentials. Review training data for potential secret leakage.",
  BIAS_DETECTION:
    "Enable bias detection scanner and implement fairness constraints. Review model outputs for demographic bias and consider fine-tuning with more balanced datasets.",
  SENSITIVE_INFO:
    "Implement sensitive information detection (HIPAA, GDPR compliance). Add data classification and handling policies based on information sensitivity level.",
};

/**
 * Get a suggested fix for a security issue type.
 * @param issueType - The type of security issue (e.g., "PII_DETECTION")
 * @returns A string describing the recommended remediation steps
 */
export function getSuggestedFixByType(issueType: string): string {
  return (
    suggestedFixesByType[issueType] ||
    "Review the security issue details and implement appropriate security controls to prevent similar issues."
  );
}
